module.exports = __webpack_public_path__ + "img/21.c95c8871.png";